export default __webpack_public_path__ + "static/media/sketch_logo2.16b03d08.png";